<template>
  <div class="progress">
    <div class="banner"></div>
    <div class="profile">
      <div class="profile-header">
        <div class="title">
          <div class="cont_tit">
            <p>新闻中心</p>
            <span>Service Hall</span>
          </div>
          <div class="crumb">
            <span>当前位置：</span>
            <a href="../" target="_self" title="首页" class="CurrChnlCls"
              >首页</a
            >&gt;<a href="" target="_self" title="新闻中心" class="CurrChnlCls"
              >新闻中心</a
            >&gt;<a target="_self" class="CurrChnlCls">{{
              queryFilter.typeIdArr == 1
                ? "集团动态"
                : queryFilter.typeIdArr == 2
                ? "招聘公告"
                : queryFilter.typeIdArr == 3
                ? "考试通知"
                : queryFilter.typeIdArr == 4
                ? "党建文化"
                : queryFilter.typeIdArr == 9
                ? "媒体聚焦"
                : ""
            }}</a>
          </div>
        </div>
      </div>
      <div class="profile-header__editor-button" v-if="Mode == 3">
        <a href="https://ks.jobhb.com/wsbm/index" target="_blank">
          <el-button plain round icon="el-icon-edit">考试报名入口</el-button>
        </a>
      </div>
      <div class="profile-conter">
        <ul class="job-tab">
          <li
            v-for="(item, index) in tabs"
            :key="index"
            class="tab-item"
            :class="{ 'item--active': Mode == item.value }"
            @click="toggleLoginMode(item.value)"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
      <div class="resumeForm">
        <div class="ant-spin-nested-loading">
          <div class="ant-spin-container">
            <ul class="content-list">
              <li
                class="recommend-item"
                v-for="(item, index) in dataList"
                :key="index"
              >
                <div v-if="item.visible == 1" class="container">
                  <a
                    :href="
                      item.jumpLink
                        ? item.jumpLink
                        : 'https://www.jobhb.com/content/' +
                          queryFilter.typeIdArr +
                          '/' +
                          item.cmCommentId
                    "
                    target="_blank"
                  >
                    <div class="top">
                      <div class="name substring">
                        <div class="day" v-if="item.releaseTime">
                          {{ item.releaseTime.split(" ")[0].split("-")[2] }}
                        </div>
                        <div class="year-month" v-if="item.releaseTime">
                          {{ item.releaseTime.split(" ")[0].split("-")[0] }}-{{
                            item.releaseTime.split(" ")[0].split("-")[1]
                          }}
                        </div>
                      </div>
                      <div class="wage substring">
                        <div class="list-title">{{ item.commentTitle }}</div>
                        <div class="content">{{ item.outline }}</div>
                      </div>
                    </div>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryFilter.pageNum"
            :limit.sync="queryFilter.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCommentListWithPage } from "@/api/index";
import store from "@/store";
export default {
  name: "announcement",
  data() {
    return {
      id: "",
      dataList: [],
      Mode: "",
      tabs: [
        {
          value: "1",
          label: "集团动态",
        },
        {
          value: "2",
          label: "招聘公告",
        },
        {
          value: "3",
          label: "考试通知",
        },
        {
          value: "4",
          label: "党建文化",
        },
        {
          value: "9",
          label: "媒体聚焦",
        },
      ],
      queryFilter: {
        pageNum: 1,
        pageSize: 10,
        typeIdArr: "",
        visible: "1",
        orderByColumn: "releaseTime",
        isAsc: "desc",
      },
      // 总条数
      total: 0,
    };
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.announcementId) {
          //需要监听的参数
          this.Mode = this.$route.query.announcementId;
          this.queryFilter.typeIdArr = this.$route.query.announcementId;
          store.setAnnouncementId(this.$route.query.announcementId);
        }
      },
    },
    Mode(newVal) {
      this.updateRouteParams(newVal);
    },
  },
  created() {
    this.Mode = this.$route.query.announcementId;
    this.queryFilter.typeIdArr = this.$route.query.announcementId;
    store.setAnnouncementId(this.$route.query.announcementId);
    this.getList();
  },
  methods: {
    toggleLoginMode(mode) {
      this.Mode = mode;
      this.queryFilter.typeIdArr = mode;
      this.getList();
    },

    updateRouteParams(query) {
      if (query) {
        this.$router.push({
          path: "/announcement",
          query: { announcementId: query },
        });
      } else {
        this.$router.push({
          path: "/announcement",
          query: { announcementId: "1" },
        });
      }
      store.setAnnouncementId(query);
      location.reload();
    },

    getList() {
      const loading = this.$loading();
      getCommentListWithPage(this.queryFilter)
        .then((res) => {
          loading.close();
          if (res.code == 200) {
            this.dataList = res.rows;
            this.total = res.total;
          }
        })
        .catch(() => {
          loading.close();
        });
    },

    // go(jumpLink, typeIdArr, cmCommentId) {
    //   if (jumpLink) {
    //     window.location.href = jumpLink;
    //   } else {
    //     this.$router.push({
    //       name: "content",
    //       params: { id: typeIdArr, cmCommentId: cmCommentId },
    //     });
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
.banner {
  background-image: url("../assets/images/xwzxpc.png");
  background-size: 100% 100%;
  padding-bottom: 32%;
  background-repeat: no-repeat;
}
.profile {
  width: 70%;
  margin: auto;
  &-header {
    padding-top: 50px;
    margin-bottom: 50px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .cont_tit {
      position: relative;
      font-weight: 800;
    }

    .cont_tit:after {
      content: "";
      position: absolute;
      background: url("../assets/images/index20231114_8.png") center center
        no-repeat;
      background-size: 100% auto;
      width: 450px;
      height: 56px;
      left: -10px;
      bottom: -30px;
    }

    .cont_tit p {
      display: inline-block;
      font-size: 30px;
      padding-right: 20px;
      line-height: 1.1;
      position: relative;
      margin-right: 20px;
      font-weight: 600;
      color: #335593;
    }

    .cont_tit p:after {
      content: "";
      position: absolute;
      height: 28px;
      width: 3px;
      left: 100%;
      bottom: 0;
      background: #7499ce;
    }

    .cont_tit span {
      display: inline-block;
      font-size: 14px;
      color: #b1b1b1;
    }

    .title .crumb {
      color: #585858;
      font-size: 18px;
    }

    .title .crumb a {
      margin: 0 10px;
      display: inline-block;
    }
  }
  &-header__editor-button {
    display: flex;
    justify-content: flex-end;
  }
  &-conter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    .job-tab {
      align-items: center;
      border-bottom: 1px solid #7499ce;
      display: -ms-flexbox;
      display: flex;
      height: 62px;
      justify-content: space-around;
      line-height: 62px;
      margin-bottom: 10px;
      width: 100%;
      .tab-item {
        cursor: pointer;
        display: block;
        font-size: 18px;
        font-weight: 500;
        height: 62px;
        line-height: 62px;
        position: relative;
      }
      .tab-item.item--active {
        color: #7499ce;
        font-weight: bold;
      }
      .tab-item.item--active:after {
        content: "";
        position: absolute;
        width: 18px;
        height: 18px;
        border-color: #7499ce #7499ce #fff #fff;
        border-style: solid;
        border-width: 1px;
        top: calc(100% - 0.49em);
        left: 50%;
        background: #fff;
        transform: rotate(-45deg) translateX(-50%) translateY(-50%);
      }
    }
  }
  .resumeForm {
    margin: 20px 0;
    background: #fff;
    box-shadow: 0px 9px 20px 0px #c2c1c180;
    border-radius: 4px;
    padding: 30px;
    .ant-spin-nested-loading {
      position: relative;
      .ant-spin-container {
        position: relative;
        -webkit-transition: opacity 0.3s;
        -o-transition: opacity 0.3s;
        transition: opacity 0.3s;
        .content-list {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          .recommend-item {
            padding: 20px 25px;
            width: 100%;
            border-bottom: 1px solid #dcdcdc;
          }

          .container {
            .top {
              -ms-flex-align: center;
              -ms-flex-pack: justify;
              align-items: center;
              display: -ms-flexbox;
              display: flex;
              justify-content: space-between;
              .name {
                box-sizing: border-box;
                background: linear-gradient(to bottom, #bce3fc, #7499ce);
                width: 80px;
                height: 90px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                color: #fff;
                margin-right: 40px;
                .day {
                  font-size: 42px;
                }
                .year-month {
                  font-size: 16px;
                }
              }
              .wage {
                width: calc(100% - 7.7em);
                height: 80px;
                .list-title {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 20px;
                  margin-bottom: 12px;
                }
                .content {
                  font-size: 16px;
                  color: #585858;
                  word-break: break-all;
                  overflow: hidden;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
            }
          }

          .container:hover {
            color: #00a0e9;
            .name {
              color: #00a0e9;
              border: 2px solid #00a0e9;
              background: #fff;
            }
          }
        }
      }
    }

    .pagination-wrapper {
      text-align: center;
    }
  }
}
</style>
